// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_1k2","cls2":"CiterightMiniReport-cls2_SO_ CiterightMiniReport-cls1_1k2"};